"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * @module base/toolkit/1_0
 * @author Henryzeng <henryzeng@lexin.com>
 * @version 1.0
 * @description 工具类组件：常用数组、对象操作方法、字符串转义等方法
 */
var Toolkit = {
  /**
   * @function getTypeString
   * @param {string} val - 变量，可为任意值
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  获取变量类型
   * @instance
   * @return {String} val
   * @example
   * M_TOOLKIT.getTypeString(function(){}); //function
  */
  getTypeString: function getTypeString(val) {
    return Object.prototype.toString.call(val);
  },

  /**
   * @function isWindow
   * @param {object} obj - 对象
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  是否为window对象
   * @instance
   * @return {Boolean} true
   * @example
   * M_TOOLKIT.isWindow({}); //false
  */
  isWindow: function isWindow(obj) {
    return obj !== null && obj === obj.window;
  },

  /**
   * @function isEmptyObject
   * @param {object} params - 对象
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  是否空对象
   * @instance
   * @return {Boolean} true
   * @example
   * M_TOOLKIT.isEmptyObject({}); //true
  */
  isEmptyObject: function isEmptyObject(params) {
    return params && Object.keys(params).length === 0;
  },

  /**
   * @function isObject
   * @param {object} val - 任意值
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  是否为对象（不包括数组）
   * @instance
   * @return {Boolean} true
   * @example
   * M_TOOLKIT.isObject({}); //true
  */
  isObject: function isObject(val) {
    return this.getTypeString(val).indexOf('Object') > -1;
  },

  /**
   * @function isFunction
   * @param {object} value - 任意值
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  是否为函数
   * @instance
   * @return {Boolean} true
   * @example
   * M_TOOLKIT.isFunction({}); //true
  */
  isFunction: function isFunction(value) {
    return typeof value == 'function';
  },

  /**
   * @function isPlainObject
   * @param {object} obj - 任意值
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  是否是一个纯粹的对象；所谓"纯粹的对象"，就是该对象是通过"{}"或"new Object"创建的。
   * @instance
   * @return {Boolean} true
   * @example
   * M_TOOLKIT.isPlainObject({}); //true
  */
  isPlainObject: function isPlainObject(obj) {
    return this.isObject(obj) && !this.isWindow(obj) && Object.getPrototypeOf(obj) == Object.prototype;
  },

  /**
   * @function trim
   * @param {string} str - 对象
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  去除空格
   * @instance
   * @return {String} str
   * @example
   * M_TOOLKIT.trim({}); //true
  */
  trim: function trim(str) {
    return str && typeof str === 'string' ? str.replace(/\s/g, '') : '';
  },

  /**
   * @function validateNumber
   * @param {string} val - 字符串
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  校验是否数字
   * @instance
   * @return {Boolean} true
   * @example
   * M_TOOLKIT.validateNumber('123a'); //false
  */
  validateNumber: function validateNumber(val) {
    return /^[0-9]*$/.test(val);
  },

  /**
   * @function validatePositiveNumber
   * @param {string} val - 字符串
   * @author melody <melody@lexin.com>
   * @description  校验是否正数，包含小数
   * @instance
   * @return {Boolean} true
   * @example
   * M_TOOLKIT.validatePositiveNumber('123a'); //false
  */
  validatePositiveNumber: function validatePositiveNumber(val) {
    return /^[0-9]*\.?[0-9]*$/.test(val);
  },

  /**
   * @function arrayIntersection
   * @param {array} array_a - a数组
   * @param {array} array_b - b数组
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  校验ab数组是否存在交集,返回交集的数组，条件为 1、ab数组各自升序排列 2、不存在重复元素
   * @instance
   * @return {array} array
   * @example
   * M_TOOLKIT.arrayIntersection(['123a'],['123a','123b']); //['123a']
  */
  arrayIntersection: function arrayIntersection(array_a, array_b) {
    var array_ai = 0,
        // a数组当前下标
    array_bi = 0,
        // b数组当前下标
    result = []; // 循环体依据输入两个数组的长度决定是否终止

    while (array_ai < array_a.length && array_bi < array_b.length) {
      // 当其中一个数组遍历完成即可终止循环
      if (array_a[array_ai] < array_b[array_bi]) {
        // 若数组A的元素小于数组B的元素，则取出数组A的下一个元素
        array_ai++;
      } else if (array_a[array_ai] > array_b[array_bi]) {
        // 若数组A的元素大于数组B的元素，则取出数组B的下一个元素
        array_bi++;
      } else {
        // 两个元素相等
        result.push(array_a[array_ai]);
        array_ai++;
        array_bi++;
      }
    }

    return result;
  },

  /**
   * @function extend
   * @param {object} ele - 页面元素
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  重构页面元素内部的属性，兼容WEB获取元素属性方法不一样的（重写jquery的extend的方法）
   * @instance
   * @return {object} ele
   * @example
   * M_TOOLKIT.extend(true, {}, {}); //第一个参数若为bool值代表是否是深拷贝，默认不是深拷贝
  */
  extend: function extend() {
    var src = null,
        // 缓存被合并的属性（未做处理）
    clone = null,
        // 缓存被合并的属性（兼容处理）
    copyIsArray = null,
        // 当前属性是否是数组
    copy = null,
        // 缓存被复制的属性
    name = '',
        // key值
    options = {},
        // 缓存被复制的入参
    target = (arguments.length <= 0 ? undefined : arguments[0]) || {},
        i = 1,
        // 入参下标
    length = arguments.length,
        deep = false; // 处理深拷贝场景

    if (typeof target === 'boolean') {
      deep = target;
      target = (arguments.length <= 1 ? undefined : arguments[1]) || {}; // 如果第一个参数是bool类型，忽略第一个参数，直接取第二个参数

      i = 2;
    } // 处理深拷贝场景里面的入参可能不是对象


    if (_typeof(target) !== 'object' && !Toolkit.isFunction(target)) {
      target = {};
    }

    for (; i < length; i++) {
      // 仅处理非null或undefined
      if ((options = i < 0 || arguments.length <= i ? undefined : arguments[i]) !== null) {
        // 拷贝后一个对象到前面的对象
        for (name in options) {
          src = target[name]; // 判断当前key值是否一样

          copy = options[name]; // 如果对应的值一样看下一个参数

          if (target === copy) {
            continue;
          } // 如果当前合并的是对象或数组 需要递归调用


          if (deep && copy && (Toolkit.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
            if (copyIsArray) {
              copyIsArray = false;
              clone = src && Array.isArray(src) ? src : [];
            } else {
              clone = src && Toolkit.isPlainObject(src) ? src : {};
            } // 递归调用


            target[name] = Toolkit.extend(deep, clone, copy); // 当copy不是对象且不是undefined则结束递归开始赋值
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    } // 返回合并后的对象


    return target;
  },

  /**
   * @instance
   * @function getValue
   * @description 对象的链式取值
   * @param  {Object} opts   选项参数
   * @param  {Object} opts.obj   对象obj {}
   * @param  {String} opts.props 值key字符串 'template_content[2].order_capital_info[0].font_color'
   * @param  {String} opts.def   默认值 obj.props 取不到对应值则返回默认值
   * @return {Any}
   * @example
   * M_TOOLKIT.getValue({ props: 'name.a[0].b.c', obj, def: '默认值' }); // 取obj.name.a[0].b.c的值，如果其中一步取不到则返回def
   */
  getValue: function getValue() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      def: ''
    };
    var obj = opts.obj,
        props = opts.props,
        _opts$def = opts.def,
        def = _opts$def === void 0 ? '' : _opts$def; // obj不是对象，或props不是字符串直接返回默认值

    if (_typeof(obj) !== 'object' || obj === null || typeof props !== 'string') {
      return def;
    }

    var temp = props.split('.'); // 分割.得到key值数组

    var field_arr = [].concat(temp); // 副本
    // 遍历分割.得到的数组，处理数组取值语法[xxx]

    temp.forEach(function (e) {
      // 匹配数组取值字符串，eq: 'data[1]'
      var matchs = e.match(/^(\w+)\[(\w+)\]$/);

      if (matchs !== null) {
        var field1 = matchs[1];
        var field2 = matchs[2];
        var index = field_arr.indexOf(e);
        field_arr.splice(index, 1, field1, field2);
      }
    }); // 遍历field_arr取值

    var ret = field_arr.reduce(function (pre, cur) {
      var target = pre[cur] || def;

      if (target instanceof Array) {
        return [].concat(target);
      }

      if (target instanceof Object) {
        return Object.assign({}, target);
      }

      return target;
    }, obj);
    return ret;
  },

  /**
   * @function rebuildAttr
   * @param {object} e - 页面元素
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  重构页面元素内部的属性，兼容WEB获取元素属性方法不一样的
   * @instance
   * @return {object} ele
   * @example
   * M_TOOLKIT.rebuildAttr(e); //true
  */
  rebuildAttr: function rebuildAttr(e) {
    var ele = e.currentTarget || e.target,
        // H5：currentTarget Native:target
    dataset = ele.dataset,
        // H5 data属性存放在dataset里面
    native_attr = {}; // 如果有dataset,则按照native模式赋值

    if (dataset) {
      for (var key in dataset) {
        var new_key = key[0].toUpperCase() + key.substring(1); // 首字母转大写

        native_attr['data' + new_key] = dataset[key];
      }

      e.target.attr = native_attr;
    }

    return e;
  },

  /**
   * @function formatTime
   * @param {string} time - 需要格式化的时间 '2019-01-01 10:00:00' 或 '2019/01/01 10:00:00' 格式（该API已废弃，建议使用日期组件的API）
   * @author Henryzeng <henryzeng@lexin.com>
   * @description  （该API已废弃，建议使用日期组件的API）
   * @instance
   * @example M_TOOLKIT.formatTime('2019-01-01 10:00:00');（该API已废弃，建议使用日期组件的API）
   * @returns {Object}
   * {{
   *      year: '2019',
   *      mon: '01',
   *      day: '01',
   *      hour: '10',
   *      min: '00',
   *      sec: '00'
   * }}
  */
  formatTime: function formatTime(time) {
    var result = [];

    if (time) {
      result = /(\d{4})[-\/](\d{2})[-\/](\d{2})[ ](\d{2}):(\d{2}):(\d{2})/.exec(time) || [];
    }

    return {
      'year': result[1] || '',
      'mon': result[2] || '',
      'day': result[3] || '',
      'hour': result[4] || '',
      'min': result[5] || '',
      'sec': result[6] || ''
    };
  },

  /**
   * @function getNumInterval
   * @param {number} num - 待处理数值 [必选]
   * @param {array} num_arr 传入的数组区间 [可选]
   * @param {object} option 扩展的信息 [可选]
   * @param {boolean} option.is_interval 是否需要输出区间 [可选]
   * @param {string} option.split_str 区间的间隔字符 [可选]
   * @description 获取数值据所在的区间
   * @instance
   * @example M_TOOLKIT.getNumInterval(4);
   * @return {string}  // 5
   */
  getNumInterval: function getNumInterval(num, num_arr, option) {
    var op = Object.assign({
      is_interval: false,
      // 是否需要输出区间
      split_str: '_' // 区间的间隔字符

    }, option);
    num_arr = num_arr && Array.isArray(num_arr) ? num_arr : [1, 2, 3, 5, 8, 10]; // 默认数组是轮询请求时间的区间段

    for (var i = 0; i < num_arr.length; i++) {
      if (num < num_arr[i]) {
        return (op.is_interval ? (num_arr[i - 1] ? num_arr[i - 1] : 0) + op.split_str : '') + num_arr[i];
      } else if (num >= num_arr[num_arr.length - 1]) {
        return num_arr[num_arr.length - 1] + op.split_str;
      }
    }
  },

  /**
   * @function getFirstRow
   * @param {array} arr 传入的数组 [必选]
   * @description 获取数组第一行数据
   * @instance
   * @example M_TOOLKIT.getFirstRow(['a']);
   * @return {*}  // a
   */
  getFirstRow: function getFirstRow(arr) {
    if (!arr) {
      return null;
    }

    return arr.length > 0 ? arr[0] : null;
  },

  /**
   * @function sleep
   * @description 休眠函数
   * @param {Int} ms
   * @returns {Promise}
   * @example
   * await M_TOOLKIT.sleep(1000)
   */
  sleep: function sleep(ms) {
    return new Promise(function (resolve) {
      return setTimeout(resolve, ms);
    });
  },

  /**
   * @function debounce
   * @param {Function} fn 执行的函数
   * @param {Int} delay 毫秒
   * @author wyanxiong <wyanxiong@lexin.com>
   * @description 防抖函数：将传入的函数包装并返回成一个防抖函数，该函数连续执行N次只会在最后一次且延迟delay毫秒后执行
   * @returns {Function}
   * @example
   * let debounceFn = M_TOOLKIT.throttle(function (a, b){}, 500) // 需要先存储返回的防抖函数，避免重复声明防抖函数，导致每次的timer都不是同一个
   * debounceFn(1,2) // 返回函数的this指向调用函数的对象
   */
  debounce: function debounce(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (!fn || typeof fn !== 'function') {
      fn = function fn() {};

      console.error('入参的函数为空或非函数');
    }

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      // 每当调用的时候把前一个 setTimeout clear 掉
      clearTimeout(timer); // 然后又创建一个新的 setTimeout, 这样就能保证delay 间隔内如果时间持续触发，就不会执行 fn 函数

      timer = setTimeout(function () {
        fn.apply(_this, args);
      }, delay);
    };
  },

  /**
   * @function throttle
   * @param {Function} fn 执行的函数
   * @param {Int} delay 毫秒
   * @author wyanxiong <wyanxiong@lexin.com>
   * @description 节流函数：将传入的函数包装并返回成一个节流函数，该函数一定时间(delay)内只会执行一次
   * @returns {Function}
   * @example
   * let throttleFn = M_TOOLKIT.throttle(function (a, b){}, 500) // 需要先存储返回的节流函数，避免重复声明节流函数，导致每次的last_time都不是同一个
   * throttleFn(1,2) // 返回函数的this指向调用函数的对象
   */
  throttle: function throttle(fn) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (!fn || typeof fn !== 'function') {
      fn = function fn() {};

      console.error('入参的函数为空或非函数');
    }

    var last_time = 0;
    return function () {
      // 函数当前执行的时间
      var now_time = new Date().getTime(); // 若函数当前执行时间距离上次函数执行时间未大于delay，函数不执行

      if (now_time - last_time > delay) {
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        fn.apply(this, args); // 更新函数最后一次执行时间

        last_time = now_time;
      }
    };
  },

  /**
   * @function retryPolling
   * @param {Function} fn 执行的函数
   * @param {object} options 选项
   * @param {number} options.count 重试次数
   * @param {number} options.interval  重试间隔
   * @param {number} options.timeout 最大允许重试时间
   * @author ashhu
   * @description 轮询重试函数：将传入的函数包装并返回成一个轮询重试函数，该函数会在一定时间内重试count次，每次间隔interval毫秒
   * @returns {Function}
   * @example
   * const someQueryFn = () => doSomeQuery(data).then(res => {
   *     if (checkSomeCondition(res)) {
   *         return res
   *     } else {
   *         return Promise.reject(res)
   *     }
   * })
   * M_TOOLKIT.retryPolling(someQueryFn, {count: 3, interval: 3000, timeout: 10 * 1000})
   *      .then(res => doSomeBusiness(res))
   *      .catch(err => errorHandler(err))
   */
  retryPolling: function retryPolling(fn) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      count: 1,
      interval: 1000,
      timeout: 0
    };

    if (typeof fn !== 'function') {
      return Promise.reject(new Error('fn must be a function'));
    } // 解构赋值


    var count = options.count,
        interval = options.interval,
        timeout = options.timeout; // 终止时间

    var end_time = Date.now() + timeout; // 已重试次数

    var attempts = 0;
    return new Promise(function (resolve, reject) {
      var execute = function execute() {
        return Promise.resolve(fn()).then(function (data) {
          return resolve(data);
        })["catch"](function () {
          if (timeout && Date.now() > end_time) {
            // 设置了超时时间，且当前时间大于超时时间的话
            return reject(new Error('Timeout exceeded.'));
          }

          attempts++;

          if (attempts <= count) {
            // 已重试次数未超过最大重试次数
            setTimeout(execute, interval);
          } else {
            return reject(new Error("Maximum number of attempts reached (".concat(count, ").")));
          }
        });
      };

      execute();
    });
  },

  /**
  * @function formatBankCard
  * @param {string} value 银行卡号
  * @author wyanxiong <wyanxiong@lexin.com>
  * @description 银行卡格式化，每四位加一个空格
  * @returns {string}
  * @example
  * M_TOOLKIT.formatBankCard('12345678123456789') // 1234 5678 1234 5678 9
  */
  formatBankCard: function formatBankCard(value) {
    if (!value) {
      return '';
    }

    var reg = new RegExp('([A-Za-z0-9]|[*]){4}', 'g');
    value = value.replace(/\s/g, '');
    value = value.replace(reg, function (key) {
      return key + ' ';
    }).replace(/\s$/, '');
    return value;
  },

  /**
  * @function maskBankCard
  * @param {string} value 银行卡号
  * @author wyanxiong <wyanxiong@lexin.com>
  * @description 银行卡号掩码，只展示前4位和后4位
  * @returns {string}
  * @example
  * M_TOOLKIT.maskBankCard('12345678123456789') // 1234*********6789
  */
  maskBankCard: function maskBankCard(value) {
    if (!value) {
      return '';
    }

    value = value.toString();
    return value.replace(/^([A-Za-z0-9]{4})([A-Za-z0-9]|\*)+([A-Za-z0-9]{4})/g, function (word, s1, s2, s3) {
      // 获取星号的长度
      var star = '*'.repeat(value.length - 8);
      return s1 + star + s3;
    });
  },

  /**
  * @function maskBankCardNo
  * @param {string} value 银行卡号
  * @author wyanxiong <wyanxiong@lexin.com>
  * @description 银行卡号掩码，只展示前4位和后2位，区别于maskBankCard
  * @returns {string}
  * @example
  * M_TOOLKIT.maskBankCard('12345678123456789') // 1234***********89
  */
  maskBankCardNo: function maskBankCardNo(value) {
    if (!value) {
      return '';
    }

    value = value.toString();
    return value.replace(/^([A-Za-z0-9]{4})([A-Za-z0-9]|\*)+([A-Za-z0-9]{2})/g, function (word, s1, s2, s3) {
      // 获取星号的长度
      var star = '*'.repeat(value.length - 6);
      return s1 + star + s3;
    });
  },

  /**
  * @function maskBankCardWithTail
  * @param {string} value 银行卡号
  * @author wyanxiong <wyanxiong@lexin.com>
  * @description 银行卡掩码处理，保留格式化的空格，只留后4位
  * @returns {string}
  * @example
  * M_TOOLKIT.maskBankCardWithTail('1234567812345678') // **** **** **** 5678
  */
  maskBankCardWithTail: function maskBankCardWithTail(value) {
    if (!value) {
      return '';
    }

    value = value.toString(); // 获取掩码后的卡号

    var str = value.replace(/^([A-Za-z0-9]|\*)+([A-Za-z0-9]{4})/g, function (word, s1, s2) {
      // 获取星号的长度
      var star = '*'.repeat(value.length - 4);
      return star + s2;
    }); // 格式化卡号

    var reg = new RegExp('([A-Za-z0-9]|[*]){4}', 'g');
    str = str.replace(/\s/g, '');
    str = str.replace(reg, function (key) {
      return key + ' ';
    }).replace(/\s$/, '');
    return str;
  },

  /**
  * @function maskName
  * @param {string} value 姓名
  * @author wyanxiong <wyanxiong@lexin.com>
  * @description 姓名掩码
  * @returns {string}
  * @example
  * M_TOOLKIT.maskName('分期乐') // 分**
  */
  maskName: function maskName(value) {
    if (!value) {
      return '';
    }

    value = value.toString();
    var nameDesc = value.slice(0, 1);
    var star = '*'.repeat(value.length - 1);
    return nameDesc + star;
  },

  /**
   * @function pickObjKeys
   * @description 选择对象的指定key生成新的obj
   * @param {Object} obj 选择的对象
   * @param {Array} keys 指定的key值
   * @return {Object} 选定key值的对象
   * @instance
   * @example
   * var obj = { a: 1, b: 2 }
   * M_TOOLKIT.pickObjKeys(obj, ['a']) // {a: 1}
   */
  pickObjKeys: function pickObjKeys(obj) {
    var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var new_obj = {};
    keys.forEach(function (key) {
      new_obj[key] = obj[key];
    });
    return Object.assign({}, new_obj);
  },

  /**
   * @function list2Map
   * @description 数组转换为后台类型数据key-value对象存储形式,用于前端取值展示
   * @param {Array} list 源数组
   * @param {String} key 选取的key值，默认为index
   * @return {Object} { 1: { index: 1, data: 'xxx' }, 2: { index: 2, data: 'yyy' } }
   * @example
   * var arr = [{ index: 1, data: 'xxx' }, { index: 2, data: 'yyy' }]
   * M_TOOLKIT.list2Map(arr) // { 1: { index: 1, data: 'xxx' }, 2: { index: 2, data: 'yyy' } }
   */
  list2Map: function list2Map() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'index';
    var obj = {}; // 以数组中每个对象元素的index属性作为key值，对象元素作为value值

    list.forEach(function (e) {
      obj[e[key]] = e;
    });
    return obj;
  },

  /**
   * @function zeroSpaceFilter
   * @param {string} str 零宽字符过滤
   * @author sinchen
   * @description 零宽字符过滤
   * @returns {string}
   */
  zeroSpaceFilter: function zeroSpaceFilter(str) {
    if (str) {
      str = (str + '').replace(/[\u200B-\u200D\u180E\u2060\uFEFF]/g, '');
    }

    return str;
  },

  /**
   * @function deepclone
   * @author karzanliu
   * @description 对象的深拷贝实现
   * @instance
   * @param {Object} source 拷贝源对象
   * @return {Object}
   */
  deepClone: function deepClone(source) {
    // 拷贝函数
    function clone(source) {
      if (!source) {
        return {};
      }

      var target = Array.isArray(source) ? [] : {};

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          //  循环遍历出所有属性，并复制给新的目标对象
          // 正则表达式
          if (source[key] instanceof RegExp) {
            target[key] = source[key];
            continue;
          }

          if (_typeof(source[key]) === 'object') {
            // 递归调用深拷贝
            target[key] = clone(source[key]);
          } else {
            target[key] = source[key];
          }
        }
      }

      return target;
    }

    return clone(source);
  },

  /**
   * @function splitArr
   * @author darcylin <darcylin@lexin.com>
   * @description 分割一维数组
   * @instance
   * @param {Array} list 分割的二维数组
   * @param {Integer} split_len 分割的长度
   * @returns {Array}
   */
  splitArr: function splitArr() {
    var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var split_len = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

    if (split_len === 0) {
      return [];
    }

    var data = []; // 一维数组

    var index = 0; // 一维下标

    for (var i = 0; i < list.length; i++) {
      index = Math.floor(i / split_len);
      data[index] = data[index] || [];
      data[index].push(list[i]); // 二维
    }

    return data;
  },

  /**
   * @function isGif
   * @author darcylin <darcylin@lexin.com>
   * @description 判断是否为gif
   * @instance
   * @param {String} str 链接
   * @returns {Boolean}
   */
  isGif: function isGif(str) {
    // 为空或者不是字符串类型返回false
    if (!str || typeof str !== 'string') {
      return false;
    } // 分割字符串


    var split_arr = str.split('?'); // 获取去除url参数的url，避免xxx.png?b=xxx.gif判断为true

    var url = split_arr[0];
    var reg = /[^\s]+\.gif/gi;
    return reg.test(url);
  },

  /**
   * @function lineToCamel
   * @author darcylin <darcylin@lexin.com>
   * @description 下划线转换驼峰
   * @instance
   * @param {String} str
   * @returns {String}
   */
  lineToCamel: function lineToCamel(str) {
    return str.replace(/\_(\w)/g, function (all, letter) {
      return letter.toUpperCase();
    });
  },

  /**
   * @function camelToLine
   * @author darcylin <darcylin@lexin.com>
   * @description 驼峰转换下划线
   * @param {String} str
   * @returns {String}
   */
  camelToLine: function camelToLine(str) {
    return str.replace(/([A-Z])/g, '_$1').toLowerCase();
  },

  /**
   * @function transformLineCamel
   * @author darcylin <darcylin@lexin.com>
   * @description 对象、数组-下划线驼峰转换
   * @param {[type]} opt
   * @param {String} type 转换类型 下划线转驼峰-lineToCamel 驼峰转下划线-camelToLine
   * @returns {[type]}
   */
  transformLineCamel: function transformLineCamel(opt, type) {
    // 非对象和数组直接返回
    if (_typeof(opt) !== 'object' || !opt) {
      return opt;
    }

    var ret = Toolkit.isObject(opt) ? {} : []; // 防止数组的下标属性返回字符串

    var keys = Toolkit.isObject(opt) ? Object.keys(opt) : opt.keys();

    var _iterator = _createForOfIteratorHelper(keys),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var key = _step.value;
        var value = opt[key]; // 对象才需要转换

        if (Toolkit.isObject(opt)) {
          key = type === 'lineToCamel' ? Toolkit.lineToCamel(key) : Toolkit.camelToLine(key);
        } // 非空对象递归转换，否则直接赋值


        ret[key] = _typeof(value) === 'object' && !!value ? Toolkit.transformLineCamel(value, type) : value;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return ret;
  },

  /**
    * @function filterObjEmptyProp
    * @author gracewei <gracewei@lexin.com>
    * @description 过滤obj中的空属性
    * @instance
    * @param {Object} obj 需要过滤空属性的对象
    * @returns {Object}
    */
  filterObjEmptyProp: function filterObjEmptyProp(obj) {
    var result = {};
    Object.entries(obj).forEach(function (kv) {
      var _kv = _slicedToArray(kv, 2),
          k = _kv[0],
          v = _kv[1]; // 不为空，则写入


      if (v !== undefined && v !== '' && v !== null) {
        result[k] = v;
      }
    });
    return result;
  },

  /**
    * @function getRandomId
    * @author wyanxiong <wyanxiong@lexin.com>
    * @description 获取英文和数字组成的随机数
    * @instance
    * @param {Number} len 控制随机数长度（默认长度=最长长度=19）
    * @returns {String}
    */
  getRandomId: function getRandomId(len) {
    var id = Date.now().toString(36);
    id += Math.random().toString(36).substr(2);
    return id.substr(0, len);
  },

  /**
   * @function isJsonStr
   * @author wyanxiong <wyanxiong@lexin.com>
   * @description 判断字符串是否JSON
   * @instance
   * @param {String} str 需要判断的字符串
   * @returns {String}
   */
  isJsonStr: function isJsonStr(str) {
    if (typeof str !== 'string') {
      return false;
    }

    try {
      var obj = JSON.parse(str);
      return this.isObject(obj);
    } catch (e) {
      return false;
    }
  },

  /**
    * @function isArray
    * @param {Array} val - 任意值
    * @author melody <melody@lexin.com>
    * @description  是否为数组
    * @instance
    * @return {Boolean}
    * @example
    * M_TOOLKIT.isArray([12,2]); // true
    */
  isArray: function isArray(val) {
    return Array.isArray(val);
  },

  /**
    * @function jsonParseSafely
    * @author melody <melody@lexin.com>
    * @description 对字符串进行安全的json parse，异常时返回 null
    * @instance
    * @param {String} str 需要判断的字符串
    * @returns {Object} 不能安全json parse 时，返回 null
    * @example
    * M_TOOLKIT.jsonParseSafely('[10,20]')
    * M_TOOLKIT.jsonParseSafely('{"a": 123, "b": 11}')
    */
  jsonParseSafely: function jsonParseSafely(str) {
    if (typeof str !== 'string') {
      return null;
    }

    try {
      var obj = JSON.parse(str);
      return obj;
    } catch (e) {
      return null;
    }
  },

  /**
    * @function checkStrJsonParseResultType
    * @author melody <melody@lexin.com>
    * @description 判断 str 进行 json parse 后的结果，是否是对应的 类型
    * @instance
    * @param {String} str 需要判断的字符串
    * @param {String|Boolean} str_type 需要判断的字符串，默认为false，当前支持的枚举，Object, Array，需要支持其他枚举时，需要拓展当前方法
    * @returns {Object} 不能安全json parse 时，返回 null
    * @example
    * M_TOOLKIT.checkStrJsonParseResultType('[10,20]', 'Object') // false
    * M_TOOLKIT.checkStrJsonParseResultType('[10,20]', 'Array') // true
    * M_TOOLKIT.checkStrJsonParseResultType('[10,20]') // true
    */
  checkStrJsonParseResultType: function checkStrJsonParseResultType(str) {
    var str_type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (typeof str !== 'string') {
      return false;
    }

    try {
      var obj = JSON.parse(str);

      if (str_type) {
        return Toolkit['is' + str_type](obj);
      }

      return true;
    } catch (e) {
      return false;
    }
  },

  /**
   * @function getCurRef
   * @author darcylin <darcylin@lexin.com>
   * @description 获取ref-兼容APP和h5节点取值问题，app需要取多一层
   * @param {DOM} ref
   * @returns {DOM}
   */
  getCurRef: function getCurRef() {
    var ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    if (!ref) {
      return {};
    }

    return ref[0] ? ref[0] : ref;
  },

  /**
   * @function filterExceptionStr
   * @author wenchongxie <wenchongxie@lexin.com>
   * @description 深度过滤对象中指定值的字符串值
   * @param {Object} obj 需要判断的对象
   * @param {Array} filter_arr 需要给对象的值过滤的值数组，基础类型
   * @example
   * M_TOOLKIT.filterExceptionStr(params, ['null', 'undefind', 'NaN'])
   */
  filterExceptionStr: function filterExceptionStr(obj) {
    var filter_arr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    // 非数组或者数组内容小于1，则不处理
    if (!Array.isArray(filter_arr) || filter_arr.length < 1) {
      return;
    }

    if (!obj || !_typeof(obj) === 'object') {
      return;
    }

    var keys = Object.keys(obj);

    for (var _i2 = 0, _keys = keys; _i2 < _keys.length; _i2++) {
      var key = _keys[_i2];
      var val = obj[key]; // 如属性值为包含在过滤名单内，则将该属性删除

      if (filter_arr.includes(val)) {
        delete obj[key];
      } else if (_typeof(val) === 'object') {
        // 如果是对象引用类型，递归调用
        Toolkit.filterExceptionStr(obj[key], filter_arr);
      }
    }
  }
};
var _default = Toolkit;
exports["default"] = _default;